import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_Signup_Signin',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportalprod.b2clogin.com/tfp/mncportalprod.onmicrosoft.com'
};

const BASE_WEB_URL = 'https://web-codemanagement.portalct.mynexuscare.com/';

const BASE_API_URL = {
  Platform: 'https://api-platform.portalct.mynexuscare.com',
  CodeManagement: 'https://api-codemanagementgateway.portalct.mynexuscare.com'
};

const CONSENT_SCOPES = [
  'https://mncportalprod.onmicrosoft.com/api/api.Write',
  'https://mncportalprod.onmicrosoft.com/api/api.Read',
  'https://mncportalprod.onmicrosoft.com/api/user_impersonation',
];

export const environment: IEnvironmentVariables = {
  b2cPolicies: b2cPolicies,
  production: true,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: BASE_WEB_URL,
  apiUrl: BASE_API_URL.CodeManagement,
  platformApiUrl: BASE_API_URL.Platform,
  registryUrl: `${BASE_API_URL.Platform}/api/app-registry`,
  authConfig: {
    config: {
      auth: {
        clientId: '121f5e9f-2ad5-453b-b06b-dd3546787749',
        postLogoutRedirectUri: `${BASE_WEB_URL}login`,
        redirectUri: `${BASE_WEB_URL}login`,
        knownAuthorities: ['mncportalprod.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`,
        navigateToLoginRequestUrl: false,
      },
    },
    angularConfig: {
      consentScopes: CONSENT_SCOPES,
       protectedResourceMap: [
        ...Object.values(BASE_API_URL).map((url) => [url, CONSENT_SCOPES] as [string, string[]])
      ],
    }
  }
};
